import { showNotification } from '../utils/helpers.js';

export function initHTMX() {
    const htmx = window.htmx;
    if (!htmx) { console.error('❌ HTMX not loaded!'); return; }

    htmx.config.requestClass          = 'htmx-request';
    htmx.config.addedClass            = 'htmx-added';
    htmx.config.settlingClass         = 'htmx-settling';
    htmx.config.swappingClass         = 'htmx-swapping';
    htmx.config.allowEval             = false;
    htmx.config.useTemplateFragments  = true;
    htmx.config.selfRequestsOnly      = true;

    // ── Headers ──────────────────────────────────────────────────
    document.body.addEventListener('htmx:configRequest', (evt) => {
        evt.detail.headers['X-Requested-With'] = 'XMLHttpRequest';
        evt.detail.headers['X-HTMX-Request']   = 'true';
        const csrf = document.querySelector('meta[name="csrf-hash"]');
        if (csrf) evt.detail.headers['X-CSRF-TOKEN'] = csrf.content;
    });

    // ── Progress bar SPA (boost uniquement) ──────────────────────
    document.body.addEventListener('htmx:beforeRequest', (evt) => {
        if (evt.detail.boosted) startProgress();
    });

    document.body.addEventListener('htmx:afterSettle', (evt) => {
        if (evt.detail.boosted) stopProgress();
    });

    document.body.addEventListener('htmx:responseError', (evt) => {
        stopProgress();
        const status = evt.detail.xhr?.status;
        showNotification(getErrorMessage(status), 'error');
    });

    console.log('🔥 HTMX configured');
}

// ── Progress bar légère (pas de spinner) ─────────────────────────
let progressTimer = null;
let progressEl    = null;

function getProgressEl() {
    if (!progressEl) {
        progressEl = document.getElementById('spa-progress');
    }
    return progressEl;
}

function startProgress() {
    const bar = getProgressEl();
    if (!bar) return;
    clearTimeout(progressTimer);
    bar.style.transition = 'none';
    bar.style.width      = '0%';
    bar.style.opacity    = '1';

    // Petite pause pour reset CSS
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            bar.style.transition = 'width 0.6s cubic-bezier(0.4, 0, 0.2, 1)';
            bar.style.width      = '70%';
        });
    });
}

function stopProgress() {
    const bar = getProgressEl();
    if (!bar) return;
    bar.style.transition = 'width 0.2s ease, opacity 0.3s ease 0.2s';
    bar.style.width      = '100%';
    progressTimer = setTimeout(() => {
        bar.style.opacity = '0';
        setTimeout(() => { bar.style.width = '0%'; }, 300);
    }, 200);
}

function getErrorMessage(status) {
    return {
        400: 'Requête invalide', 401: 'Non autorisé', 403: 'Accès refusé',
        404: 'Page non trouvée', 422: 'Données invalides',
        500: 'Erreur serveur',   503: 'Service indisponible',
    }[status] ?? 'Une erreur est survenue';
}